<template>
  <BaseLayout>
    <template #drawer-left>
      <Sidebar>
        <v-list>
          <BackListItem :title="$t('back_to_start_page')" :parent="{ url: '/' }" />
        </v-list>
      </Sidebar>
    </template>
    <v-card>
      <v-card-title>
        <h1 class="grow display-1">{{ $t('systemMessages') }}</h1>
        <SystemMessageModal ref="addSystemMessageModal" :types="types" @success="refresh" />
        <ActionBtn color="primary" icon="mdi-plus" @click="openAddDialog" />
      </v-card-title>
      <v-card-text>
        <SystemMessageTable ref="systemMessageTable" :types="types" />
      </v-card-text>
    </v-card>
  </BaseLayout>
</template>

<script>
import { api } from '@/api'
import { createLink } from '@/api/helpers'

export default {
  name: 'SystemMessage',
  data() {
    return {
      types: [],
    }
  },
  async created() {
    await this.fetchTypes()
  },
  methods: {
    async fetchTypes() {
      try {
        const { data } = await api.get(createLink('system_message_type'))
        this.types = data
      } catch (e) {
        this.notifyError(this.$t('systemMessage.fetchError'))
      }
    },
    openAddDialog() {
      this.$refs.addSystemMessageModal.open()
    },
    refresh() {
      this.$refs.systemMessageTable.refresh()
    },
  },
}
</script>
